module.exports = __webpack_public_path__ + "img/768.4e4d75a5.jpg";